import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OutsideClickDirective } from './ls-outsideClick.directive';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [OutsideClickDirective],
  exports: [OutsideClickDirective]
})
export class OutsideClickModule {}
